import firebase from "firebase/app";
import { v4 as uuidv4 } from "uuid";

const documentRef = () => {
  const db = firebase.firestore();
  const currentUser = firebase.auth().currentUser;
  return db.doc(`categories/${currentUser.uid}`);
};

export default {
  namespaced: true,
  state: {
    categories: {
      income: [],
      expense: [],
    },
  },
  mutations: {
    addCategory(state, { categoryToAdd, type }) {
      state.categories[type].push(categoryToAdd);
    },
    setCategories(state, categories) {
      state.categories = categories;
    },
    editCategory(state, { categoryToEdit, type }) {
      state.categories[type] = state.categories[type].map((category) => {
        if (category.id === categoryToEdit.id) {
          category = categoryToEdit;
        }
        return category;
      });
    },
    deleteCategory(state, { categoryToDelete, type }) {
      state.categories[type] = state.categories[type].filter(
        (category) => category.id !== categoryToDelete.id
      );
    },
    resetCategories(state) {
      state.categories = {
        income: [],
        expense: [],
      };
    },
  },
  getters: {
    categoriesIncome(state) {
      return state.categories.income;
    },
    categoriesExpense(state) {
      return state.categories.expense;
    },
  },
  actions: {
    getCategories({ commit, state }) {
      if (
        state.categories &&
        state.categories.income.length !== 0 &&
        state.categories.expense.length !== 0
      ) {
        return new Promise((resolve) => {
          resolve();
        });
      }

      return new Promise((resolve, reject) => {
        documentRef()
          .get()
          .then((doc) => {
            let categories = {};
            if (doc.data()) {
              categories = doc.data();
              if (categories && !categories.income) {
                categories.income = [];
              }
              if (categories && !categories.expense) {
                categories.expense = [];
              }

              commit("setCategories", categories);
            }

            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    deleteCategory({ commit, state }, categoryToDelete) {
      const type = categoryToDelete.type;
      delete categoryToDelete.type;

      let update = {
        [type]: [...state.categories[type]],
      };
      update[type] = update[type].filter(
        (category) => category.id !== categoryToDelete.id
      );

      return new Promise((resolve, reject) => {
        documentRef()
          .update(update)
          .then(() => {
            commit("deleteCategory", {
              categoryToDelete,
              type,
            });
            resolve();
          })
          .catch((error) => reject(error));
      });
    },
    addCategory({ commit, state }, { categoryToAdd, type }) {
      categoryToAdd.id = uuidv4();
      delete categoryToAdd.type;

      const update = {
        [type]: [...state.categories[type], categoryToAdd],
      };

      return new Promise((resolve, reject) => {
        return firebase
          .firestore()
          .runTransaction((transaction) => {
            // Gets document and if not exist create
            // If exists update
            return transaction.get(documentRef()).then((doc) => {
              if (!doc.exists) {
                documentRef().set(update);
              } else {
                transaction.update(documentRef(), update);
              }
            });
          })
          .then(() => {
            commit("addCategory", { categoryToAdd, type });
            resolve();
          })
          .catch((error) => reject(error));
      });
    },
    editCategory({ commit, state }, { categoryToEdit, originalCategory }) {
      const switchType = categoryToEdit.type !== originalCategory.type;
      const type = categoryToEdit.type;
      delete categoryToEdit.type;

      let update;
      if (switchType) {
        update = {
          [type]: [...state.categories[type]],
          [originalCategory.type]: [...state.categories[originalCategory.type]],
        };

        // move to new type
        update[type].push(categoryToEdit);

        // remove from old type
        update[originalCategory.type] = update[originalCategory.type].filter(
          (category) => category.id !== categoryToEdit.id
        );
        console.log(update);
      } else {
        update = {
          [type]: [...state.categories[type]],
        };

        update[type] = update[type].map((category) => {
          if (category.id === categoryToEdit.id) {
            category = categoryToEdit;
          }
          return category;
        });
      }

      return new Promise((resolve, reject) => {
        documentRef()
          .update(update)
          .then(() => {
            if (switchType) {
              commit("setCategories", update);
            } else {
              commit("editCategory", {
                categoryToEdit,
                type,
              });
            }

            resolve();
          })
          .catch((error) => reject(error));
      });
    },
  },
};
